import { Assessment, Menu } from "@material-ui/icons";
import { Button, Edit, TopToolbar, useNotify, useRedirect } from "react-admin";
import { Spacer } from "../../components/spacer";
import { QuizAssessmentAvailabilityForm } from "./component/quiz-assessment-availability.form";


const EditActions = ({ data }) => {
  const redirect = useRedirect()

  return (
    <TopToolbar>
      <Button
        label={'Retornar'}
        onClick={() => redirect(`/quiz-assessment-availability`)}
      >
        <Menu />
      </Button>
      <Spacer />
      <Button
        label={'Resultados'}
        onClick={() => redirect(`/quiz-assessment-availability/results/${data.id}`)}
      >
        <Assessment />
      </Button>
    </TopToolbar>
  )
}

export function QuizAssessmentAvailabilityEdit(props) {
  const redirect = useRedirect()
  const notify = useNotify()

  const onSuccess = ({ data }) => {
    notify('Disponibilidade editada com sucesso')
    redirect('/')
  }


  return (
    <>
      <Edit
        title={'Editar Avaliação'}
        mutationMode="pessimistic"
        onSuccess={onSuccess}
        actions={<EditActions />}
        transform={record => ({
          ...record,
          question_bank: null
        })}
        {...props}
      >
        <QuizAssessmentAvailabilityForm />
      </Edit>
    </>
  )
}
